"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IconHeading_1 = require("./IconHeading");
exports.default = IconHeading_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/IconHeading/index.js
// module id = 1698
// module chunks = 8